const styles = {
	wrapper: {
		display: 'flex',
		flexDirection: ['row', 'column'],
		alignItems: ['flex-start', 'center'],
		paddingX: [0, 20],
		img: {
			marginBottom: [0, 30],
			marginRight: [15, 0],
			marginTop: [-1, 0],
		},
		h4: {
			color: 'primary',
			fontFamily: 'body',
			fontSize: 1,
			fontWeight: 700,
			marginBottom: 10,
		},
		p: {
			margin: 0,
			fontSize: 0,
			lineHeight: 2,
		},
	},
};

export default styles;
